module.exports = __webpack_public_path__ + "img/circulopoesia.8403db31.jpg";